import {Appointment, Provider, Vaccine} from '../../services/service-mappers/AppointmentSchedulingMapper';
import {IPatientTicketAndApptSummary} from '../../services/service-mappers/PaymentServiceMapper';
import {
  PAYMENT_METHOD_ID,
  PATIENT_PAYMENT_DETAILS_ID,
  PATIENT_PAYMENT_TOKEN,
  SCHEDULE_SEND_DATE,
  GUARANTOR_CARD_PAYMENT,
  GUARANTOR_PAY_AMOUNT,
  GUARANTOR_PAY_CASH_AMOUNT,
  GUARANTOR_LOGIN,
  PAYMENT_CLINIC_DETAILS,
  PAYMENT_SHOW_DUE_NOTICE,
  SET_LOGOUT_AUTH,
  BASE_DETAILS,
  PAYMENT_TYPE,
  ADHOC_PAYMENT_DATA,
  PAYMENT_AMOUNTS_DATA,
  GUARANTOR_LOGOUT,
  BALANCE_FORWARD_DATA,
  LOCATIONS,
  INSTALLMENT_DETAILS,
  RESET_PAYMENTS_REDUCER,
  SET_APPOINTMENT_PORTAL_PATIENT_ID,
  SET_PATIENT_APPT_AND_TICKET_SUMMARY,
  UPDATE_SCHEDULED_APPOINTMENT,
  GET_APPOINTMENT_SLOT
} from '../actions/Index';

const initState = {
  paymentMethodId: '',
  patientPaymentDetailsId: '',
  patientPaymentsToken: '',
  guarantorPaymentResult: {},
  payAmount: 0,
  payCashAmount: 0,
  paymentType: null,
  paymentAmountDetails: null,
  balanceForwardData: null,
  patients: null,
  guarantorDueIncluded: null,
  guarantorDetails: null,
  clinicId: null,
  paymentNote: '',
  insuranceName: '',
  scheduleSendDate: null,
  clinicDetails: {},
  baseDetails: {},
  showDueNoticeFirstTime: true,
  isLogin: false,
  locations: [],
  installmentDetails: {},
  patientIdForAppointmentPortal: undefined as number | undefined,
  patientApptAndTicketSummary: [] as IPatientTicketAndApptSummary[],
  clinicIdForAppointmentPortal: undefined as number | undefined,
  apptDetails: {
    updateAppointment: false,
    appointmentId: -1,
    patientFirstName: '',
    patientLastName: '',
    patientMiddleName: '',
    appointmentAt: null as null | any,
    vaccineId: null as null | number,
    patientId: null as null | number,
    createdBy: null as null | number,
    vaccineName: '',
    duration: undefined as number | undefined,
    vaccine: undefined as Vaccine | undefined,
    appointment: undefined as Appointment | undefined,
    provider: undefined as Provider | undefined
  },
  appointmentSlot: null as any
};

export default function (state = initState, action: any): typeof initState {
  const {type, payload} = action;
  switch (type) {
    case PAYMENT_METHOD_ID:
      return {
        ...state,
        paymentMethodId: payload.paymentMethodId
      };
    case PATIENT_PAYMENT_DETAILS_ID:
      return {
        ...state,
        patientPaymentDetailsId: payload.patientPaymentDetailsId
      };
    case GUARANTOR_LOGOUT:
      return {
        ...initState
      };
    case PATIENT_PAYMENT_TOKEN:
      return {
        ...state,
        patientPaymentsToken: payload.patientPaymentsToken
      };
    case SCHEDULE_SEND_DATE:
      return {
        ...state,
        scheduleSendDate: payload.scheduleSendDate
      };
    case GUARANTOR_CARD_PAYMENT:
      return {
        ...state,
        guarantorPaymentResult: payload.paymentResult
      };
    case GUARANTOR_PAY_AMOUNT:
      return {
        ...state,
        payAmount: payload.payAmount
      };
    case GUARANTOR_PAY_CASH_AMOUNT:
      return {
        ...state,
        payCashAmount: payload.payCashAmount
      };
    case GUARANTOR_LOGIN:
      return {
        ...state,
        // patientPaymentsToken: null,
        isLogin: payload.isLogin
      };
    case PAYMENT_CLINIC_DETAILS:
      return {
        ...state,
        // patientPaymentsToken: null,
        clinicDetails: payload.data
      };
    case BASE_DETAILS:
      return {
        ...state,
        baseDetails: payload.data
      };
    case PAYMENT_SHOW_DUE_NOTICE:
      return {
        ...state,
        // patientPaymentsToken: null,
        showDueNoticeFirstTime: payload.data
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    case PAYMENT_TYPE:
      return {
        ...state,
        paymentType: payload.data
      };
    case ADHOC_PAYMENT_DATA:
      return {
        ...state,
        patients: payload.data.patients,
        guarantorDueIncluded: payload.data.guarantorDueIncluded,
        guarantorDetails: payload.data.guarantor,
        clinicId: payload.data.clinic_id,
        paymentNote: payload.data.payment_note,
        insuranceName: payload.data.insurance_name
      };
    case PAYMENT_AMOUNTS_DATA:
      return {
        ...state,
        paymentAmountDetails: payload.data
      };
    case BALANCE_FORWARD_DATA:
      return {
        ...state,
        balanceForwardData: payload.data
      };
    case LOCATIONS:
      return {
        ...state,
        locations: payload.locations
      };
    case INSTALLMENT_DETAILS:
      return {
        ...state,
        installmentDetails: payload
      };
    case RESET_PAYMENTS_REDUCER:
      return {
        ...initState
      };
    case SET_APPOINTMENT_PORTAL_PATIENT_ID: {
      return {
        ...state,
        patientIdForAppointmentPortal: payload.patientId,
        clinicIdForAppointmentPortal: payload.clinicId
      };
    }
    case SET_PATIENT_APPT_AND_TICKET_SUMMARY: {
      return {
        ...state,
        patientApptAndTicketSummary: payload.patientApptAndTicketSummary
      };
    }
    case UPDATE_SCHEDULED_APPOINTMENT: {
      return {
        ...state,
        apptDetails: {
          updateAppointment: payload.updateAppointment,
          appointmentId: payload.appointmentId,
          patientFirstName: payload.patientFirstName,
          patientLastName: payload.patientLastName,
          patientMiddleName: payload.patientMiddleName,
          appointmentAt: payload.appointmentAt,
          vaccineId: payload.vaccineId,
          patientId: payload.patientId,
          createdBy: payload.createdBy,
          vaccineName: payload?.vaccineName,
          duration: payload?.duration,
          vaccine: payload?.vaccine,
          appointment: payload?.appointment,
          provider: payload?.provider
        }
      };
    }
    case GET_APPOINTMENT_SLOT: {
      return {
        ...state,
        appointmentSlot: payload.appointmentSlot
      };
    }
    default:
      return state;
  }
}
